export default __webpack_public_path__ + "static/media/bathtub_white.ff9d83f3.svg";